module.exports = __webpack_public_path__ + "img/techwolf.50701791.png";